/**
 * Outfitters-style card add-to-bag:
 * bag on the image → size pills → add variant → open cart drawer.
 * Event delegation so homepage carousels and AJAX-refreshed grids keep working.
 */
(function () {
  if (window.__cardQuickAddBound) return;
  window.__cardQuickAddBound = true;

  function cartAddUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart/add.js';
    }
    return '/cart/add.js';
  }

  function closestCard(node) {
    var imgWrap = node.closest('[class*="-card-img-wrap"]');
    return (
      node.closest('.product-card-wrapper') ||
      node.closest('.card-wrapper') ||
      (imgWrap && imgWrap.parentElement) ||
      node.closest('[class*="-card-"]') ||
      node.parentElement
    );
  }

  function selectedColor(root) {
    var card = closestCard(root);
    if (!card) return '';
    var active =
      card.querySelector('.card__swatch--active') ||
      card.querySelector('[class*="swatch-active"]') ||
      card.querySelector('[class*="swatch--active"]');
    if (!active) return '';
    return (active.getAttribute('data-color-value') || active.getAttribute('title') || '').trim();
  }

  function filterSizes(root) {
    var sizes = root.querySelector('[data-quick-add-sizes]');
    if (!sizes) return;
    var color = selectedColor(root);
    var colorPos = parseInt(root.getAttribute('data-color-pos'), 10) || 0;
    var seen = {};
    var visibleCount = 0;

    sizes.querySelectorAll('[data-quick-add-size]').forEach(function (btn) {
      var sizeVal = btn.getAttribute('data-size') || '';
      var btnColor = (btn.getAttribute('data-color') || '').trim();
      var matchesColor = !colorPos || !color || !btnColor || btnColor.toLowerCase() === color.toLowerCase();
      var duplicate = matchesColor && sizeVal && seen[sizeVal];
      if (matchesColor && sizeVal) seen[sizeVal] = true;
      var show = matchesColor && !duplicate;
      btn.hidden = !show;
      if (show) visibleCount += 1;
    });

    if (visibleCount === 0) {
      var unique = {};
      sizes.querySelectorAll('[data-quick-add-size]').forEach(function (btn) {
        var sizeVal = btn.getAttribute('data-size') || '';
        var duplicate = sizeVal && unique[sizeVal];
        if (sizeVal) unique[sizeVal] = true;
        btn.hidden = Boolean(duplicate);
      });
    }
  }

  function closeAll(except) {
    document.querySelectorAll('[data-card-quick-add].is-open').forEach(function (el) {
      if (el === except) return;
      el.classList.remove('is-open');
      var panel = el.querySelector('[data-quick-add-sizes]');
      if (panel) panel.hidden = true;
    });
  }

  function openPicker(root) {
    closeAll(root);
    filterSizes(root);
    root.classList.add('is-open');
    var panel = root.querySelector('[data-quick-add-sizes]');
    if (panel) panel.hidden = false;
  }

  function closePicker(root) {
    root.classList.remove('is-open');
    var panel = root.querySelector('[data-quick-add-sizes]');
    if (panel) panel.hidden = true;
  }

  function addToCart(variantId, trigger) {
    if (!variantId) return Promise.reject(new Error('Missing variant'));

    if (trigger) {
      trigger.classList.add('is-loading');
      trigger.setAttribute('aria-disabled', 'true');
    }

    var cartDrawer = document.querySelector('cart-drawer');
    var sections =
      cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map(function (s) {
            return s.id;
          })
        : ['cart-drawer', 'cart-icon-bubble'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);

    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          throw new Error(result.data.description || result.data.message || 'Add to cart failed');
        }

        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          if (typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(result.data);
          } else if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'card-quick-add',
            productVariantId: variantId,
            cartData: result.data,
          });
        }

        return result.data;
      })
      .finally(function () {
        if (trigger) {
          trigger.classList.remove('is-loading');
          trigger.removeAttribute('aria-disabled');
        }
      });
  }

  document.addEventListener(
    'click',
    function (event) {
    var toggle = event.target.closest('[data-quick-add-toggle]');
    var sizeBtn = event.target.closest('[data-quick-add-size]');
    var root = event.target.closest('[data-card-quick-add]');

    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      root = toggle.closest('[data-card-quick-add]');
      if (!root || toggle.disabled) return;

      if (root.getAttribute('data-has-size') === 'true' && root.querySelector('[data-quick-add-size]')) {
        if (root.classList.contains('is-open')) {
          closePicker(root);
        } else {
          openPicker(root);
        }
      } else {
        addToCart(root.getAttribute('data-default-variant'), toggle).catch(function (err) {
          console.error(err);
        });
      }
      return;
    }

    if (sizeBtn) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      if (sizeBtn.disabled || sizeBtn.getAttribute('aria-disabled') === 'true') return;
      root = sizeBtn.closest('[data-card-quick-add]');
      addToCart(sizeBtn.getAttribute('data-variant-id'), sizeBtn)
        .then(function () {
          if (root) closePicker(root);
        })
        .catch(function (err) {
          console.error(err);
        });
      return;
    }

    if (!root) closeAll();
    },
    true
  );

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') closeAll();
  });
})();
